/**
 * `datetime-local` TextField <-> ISO-8601 conversions (house pattern from
 * `features/catalog/ui/components/PriceCellEditorDrawer.tsx`, copied locally per FSD).
 */

/** `"2026-07-23T10:00"` (local, no timezone) -> ISO string, or `undefined` if blank/invalid. */
export function toIsoOrUndefined(local: string): string | undefined {
  if (!local.trim()) return undefined;
  const d = new Date(local);
  return Number.isNaN(d.getTime()) ? undefined : d.toISOString();
}

/** ISO string -> a `datetime-local` input value, or `''` if absent/invalid. */
export function toLocalInputValue(iso?: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const offsetMs = d.getTimezoneOffset() * 60000;
  return new Date(d.getTime() - offsetMs).toISOString().slice(0, 16);
}
